import { Action } from "redux";
import { IWorkflowItem, IWorkflowItemStep } from "../../../common/sharedTypes";

export interface IDataTranscriberValidationQueueState {
  workflowItemSteps: IWorkflowItemStep[];
  openWorkflowItemStep: IWorkflowItemStep;
  id: string;
  loadingWorkflowSteps: boolean;
  totalWorkflowItemSteps: number;
}

// ACTIONS
export interface IDataTranscriberValidationQueueAction extends Action {
  type: "@@dataentryqueue/GET_DATA_ENTRY_QUEUE_REPORTS";
  payload: {};
}

export enum DataTranscriberValidationQueueActionTypes {
  SEARCH_REPORTS = "@@transcribeValidationQueue/GET_DATA_ENTRY_QUEUE_REPORTS",
  GET_REPORT_DATA = "@@transcribeValidationQueue/GET_REPORT_DATA",
  OPEN_REPORT = "@@transcribeValidationQueue/OPEN_REPORT",
  ASSIGN_AND_OPEN_REPORT = "@@transcribeValidationQueue/ASSIGN_AND_OPEN_REPORT",
  UNASSIGN = "@@transcribeValidationQueue/UNASSIGN",
  COMPLETE_DATA_ENTRY = "@@transcribeValidationQueue/COMPLETE_DATA_ENTRY",
  SAVE_DATA_TRANSCRIBE_VALIDATION = "@@transcribeValidationQueue/SAVE_DATA_TRANSCRIBE_VALIDATION",
  LOADING_WORKFLOW_STEPS = "@@transcribeValidationQueue/LOADING_WORKFLOW_STEPS",
  TOTAL_WORKFLOW_STEPS = "@@transcribeValidationQueue/TOTAL_WORKFLOW_STEPS",
}

export type QNotificationActions = IDataTranscriberValidationQueueAction;
